import apiClient from './apiClient'


const getContractTemplates = (tenant, skip, take, search, orderBy, desc) => {
  const params = {
    skip,
    take,
    keyword: search,
    orderBy,
    desc
  }
  return apiClient.get(`/${tenant}/ContractTemplate`, { params })
}

const getContractTemplate = (tenant, id) => {
  return apiClient.get(`/${tenant}/ContractTemplate/${id}`)
}

const createContractTemplate = (tenant, template) => {
  return apiClient.post(`/${tenant}/ContractTemplate`, template)
}

const updateContractTemplate = (tenant, id, template) => {
  return apiClient.put(`/${tenant}/ContractTemplate/${id}`, template)
}

const deleteContractTemplate = (tenant, id) => {
  return apiClient.delete(`/${tenant}/ContractTemplate/${id}`)
}


export default {
  getContractTemplates,
  getContractTemplate,
  createContractTemplate,
  updateContractTemplate,
  deleteContractTemplate
}
